<div class="col-lg-12 col-md-12 col-12">
    <div class="bk-title--default text-center mb--70">
         <h6 class="heading heading-h6 theme-color"></h6>
         <div class="bkseparator--30"></div>
         <h3 class="heading heading-h3"><br>Conexión Akashico<sup>®</sup> Practicante</h3>
     </div>
     <div class="row">
        
       <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9988458838.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Sandy Robaldino Aguilar</li>
                     <li>sandybelrobaldino@gmail.com</li>
                     <li>TEL. 9988458838</li>
                     <li>Cancún, Quintana Roo</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
           <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9613688856.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Tere Melgar</li>
                     <li>yolotzin.tere@gmail.com</li>
                     <li>TEL. 9613688856</li>
                     <li>Tuxtla Gutiérrez, Chiapas</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->      
         
         <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9971215892.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Yessy Amor Cano Bracamontes</li>
                     <li>yessyamor@live.com.mx</li>
                     <li>TEL. 9971215892</li>
                     <li>Ticul, Yucatán</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
                    <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9631295681.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>María de Jesús coutiño Vázquez</li>
                     <li>chusy3279@hotmail.com</li>
                     <li>TEL. 9631295681</li>
                     <li>Comitán de Domínguez, Chiapas</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
                <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9676799940.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li> María de Lourdes Lara Avendaño</li>
                     <li>lourdeslaraavendano@gmail.com</li>
                     <li>TEL. 9676799940</li>
                     <li>Comitán de Domínguez, Chiapas</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
                        
         
         
         
         
         

       
     </div>
 </div>
